import Axios from 'axios';
import { StaticTranslationResponseMulti, StaticTranslationResponseSingle, TranslationKeys } from '@/types/responses';
import { StaticTranslation, UnsavedStaticTranslation, StaticTranslationInterface } from '@/types/translations';

class StaticTranslationsService {
  public fetchAll(): Promise<StaticTranslation[]> {
    return new Promise((resolve, reject) => {
      Axios.get('/translations/static').then(
        (response: StaticTranslationResponseMulti) => resolve(StaticTranslation.fromResponseMulti(response)),
      ).catch(reject);
    });
  }

  public create(translation: UnsavedStaticTranslation): Promise<StaticTranslation> {
    return new Promise((resolve, reject) => {
      Axios.post('translations/static', translation).then(
        (response: StaticTranslationResponseSingle) => resolve(StaticTranslation.fromResponseSingle(response)),
      ).catch(reject);
    });
  }

  public update(translation: StaticTranslationInterface): Promise<StaticTranslation> {
    return new Promise((resolve, reject) => {
      Axios.patch(`translations/static/${translation.id}`, translation).then(
        (response: StaticTranslationResponseSingle) => resolve(StaticTranslation.fromResponseSingle(response)),
      ).catch(reject);
    });
  }

  public delete(translation: StaticTranslationInterface): Promise<StaticTranslationInterface> {
    return new Promise((resolve, reject) => {
      Axios.delete(`translations/static/${translation.id}`).then((response) => {
        if (response.data.successful) {
          resolve(translation);
        } else {
          reject(response.data);
        }
      }).catch(reject);
    });
  }

  public fetchKeys(): Promise<string[]> {
    return new Promise((resolve, reject) => {
      Axios.get('/translations/keys').then(
        (response: TranslationKeys) => resolve(response.data),
      ).catch(reject);
    });
  }
}

export default new StaticTranslationsService();
